import axios from 'axios'

const state = {
  //step1
  selectedCountry: null,
  selectedUser: null,
  selectedDistributor: null,
  startDate: null,
  testPeriod: '',
  logoPath: '',
  changes: [],
  //step2
  name: '',
  type: '',
  sales: {
    name: '',
    phone: '',
    email: '',
  },
  marketing: {
    name: '',
    phone: '',
    email: '',
  },
  stores: {
    number: '',
    potentialRollouts: '',
    description: '',
  },
  distributorFiles: [],
  keyAccountFiles: [],
  //step3
  equipment: [],
  apex: {
    headunitsNew: '',
    headunitsRefurbished: '',
    smallPrinters: [],
    smallPrintersNew: {
      '7000 NEW 6R': '',
      '7000 NEW 5R': '',
    },
    smallPrintersRefurbished: {
      '7000 ref': '',
      '7015 ref': '',
    },
    largePrinters: [],
    largePrintersNew: {
      '88xx NEW': '',
      'D4600 NEW': '',
    },
    largePrintersRefurbished: {
      '8800 ref': '',
      '8810 ref': '',
      'D4000 ref': '',
    },
    cabinets: {
      'APEX 30': '',
      'APEX 40': '',
      'APEX 70': '',
    },
  },
  kiosk: {
    headunits: [],
    headunitsNew: {
      'G20': '',
      'Janus': '',
    },
    headunitsRefurbished: {
      'G4XL 1 ref': '',
      'G4XL 2 ref': '',
    },
    smallPrinters: [],
    smallPrintersNew: {
      '305 Printer 6R': '',
      '305 Printer 5R': '',
      '6900 new 6R': '',
      '6900 new 5R': '',
    },
    smallPrintersRefurbished: {
      '6800 ref 6R': '',
      '6850 ref 6R': '',
    },
    largePrinters: [],
    largePrintersNew: {
      '88xx NEW': '',
      'D4600 NEW': '',
    },
    largePrintersRefurbished: {
      '8800 ref': '',
      '8810 ref': '',
      'D4000 ref': '',
    },
    cabinets: [],
    cabinetsNew: {
      'Skipper 17': '',
      'Skipper 24': '',
      'Transformer 24': '',
      '6900 Cabinet 17': '',
    },
    cabinetsRefurbished: {
      'Transformer ref 17': '',
      'Transformer ref 24': '',
    },
  },
  standalone: {
    smallPrinters: [],
    smallPrintersNew: {
      '305 Printer 6R': '',
      '305 Printer 5R': '',
      '6900 new 6R': '',
      '6900 new 5R': '',
      '7000 NEW 6R': '',
      '7000 NEW 5R': '',
    },
    smallPrintersRefurbished: {
      '7000 ref': '',
      '7015 ref': '',
      '6800 ref': '',
      '6850 ref': '',
    },
    largePrinters: [],
    largePrintersNew: {
      '88xx NEW': '',
      'D4600 NEW': '',
    },
    largePrintersRefurbished: {
      '8800 ref': '',
      '8810 ref': '',
      'D4000 ref': '',
    },
    connections: [],
  },
  software: '',
  rbm: '0',
  storesNumber: '',
  printingDevices: '',
  //step4
  currency: 'euro',
  originalCurrency: '',
  exchangesTo: '',
  products5R: {},
  products6R: {},
  products8R: {},
  productsCreative: [],
  //step5
  communicationPOS: [],
  communicationSM: [],
  communicationKA: [],
  targetgroup: '',
  //hack
  trialPosCommunications: [],
  trialKaCommunications: [],
  trialSmCommunications: [],
  //step6
  promosDuringTest: [],
  trialPromos: [],
  kodakmoments: false,
  co: false,
  company: false,
  companyWebsite: '',
  rollOutPromotions: [],
  //generaldocuments
  generalDocuments: [],
  //generaldocumentsFolders
  generalDocumentsFolders: [],
  //dragandrdop
  drag: false,
  dragDoc: null,
  dragDomDoc: null,
  startPosition: null,
  startOffset: null,
}

export default state



// WEBPACK FOOTER //
// ./resources/js/store/state.js